'use strict';

define('lib/helpers/disclaimerMpg',['Handlebars'], function (Handlebars) {
  Handlebars.registerHelper('disclaimerMpg', function (opt) {
    return new Handlebars.SafeString(
      BATSiteConfig.customMpg[opt.hash.series]
        ? BATSiteConfig.customMpg[opt.hash.series].copy
        : opt.hash.default
    );
  });
});

